import { QueryClient } from "@tanstack/react-query";

// No retry (axios interceptor handles auth), no focus refetch (PDF export), 30s stale.
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});
